var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSuccess = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170 81.5943V89.0463C169.99 106.513 164.334 123.509 153.876 137.499C143.417 151.489 128.717 161.723 111.966 166.676C95.2162 171.628 77.3138 171.034 60.9292 164.98C44.5446 158.927 30.5557 147.74 21.0488 133.087C11.5419 118.433 7.02631 101.1 8.17558 83.6705C9.32486 66.2413 16.0774 49.6506 27.4261 36.3726C38.7747 23.0947 54.1115 13.841 71.1491 9.99154C88.1867 6.14213 106.012 7.90329 121.967 15.0124M170 24.2L89 105.281L64.7 80.981",
    stroke: "#00D274",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/success.7b822dd9.svg";
export { ForwardRef as ReactComponent };